const IME_PROCESSING_KEY_CODE = 229;

/** Enter submits, Shift+Enter adds a line, Escape cancels; keys that belong to an IME are left alone. */
export const submitOrCancelOnKey =
  (onSubmit: () => void, onCancel: () => void) => (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.nativeEvent.isComposing || e.keyCode === IME_PROCESSING_KEY_CODE) return;
    if (e.key === "Escape") {
      onCancel();
    } else if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };
